import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ens from './locales/en'
import trs from './locales/tr'
import des from './locales/de'
import locale_de from 'element-ui/lib/locale/lang/de'
import locale_tr from 'element-ui/lib/locale/lang/tr-TR'
import locale_en from 'element-ui/lib/locale/lang/en'
import Element from 'element-ui'

Vue.use(VueI18n)

var lang = navigator.language || navigator.userLanguage
var language;

if (!localStorage.getItem('language')) {
  language = localStorage.setItem("language", lang.split('-')[0]);
}

if (localStorage.getItem('language')) {
  language = localStorage.getItem('language');
}

const messages = {
  tr: {
    ...trs,
    ...locale_tr
  },
  en: {
    ...ens,
    ...locale_en
  },
  de: {
    ...des,
    ...locale_de
  }
}

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export const i18n = new VueI18n({
  locale: language,
  fallbackLocale: 'tr',
  messages
})



// WEBPACK FOOTER //
// ./src/plugin/i18n.js